/**
 * Search Form Toggle
 *
 * Event listeners for opening and closing the search form and the dimmer overlay. The search form is displayed
 * by sliding in from the right and is centered on the screen. The dimmer overlay fades in to give focus to the search form.
 * Closing the search form or clicking on the dimmer overlay will reverse these animations, hiding the search form and fading out the dimmer.
 *
 */
jQuery(document).ready(function ($) {
    const $searchForm = $('#search-form');
    const $searchDimmer = $('#dimmer');



    $('#search-button').on('click', function () {
        // Calculate the position of the button
        const buttonOffset = $(this).offset();
        //const buttonHeight = $(this).outerHeight();

        $('body').addClass('no-scroll');

        // Align the model with the button's right side
        $searchForm.css({
            top: buttonOffset.top + 'px', // Position it below the button
        });

        // Show the dimmer and then fade it in
        $searchDimmer.css('display', 'block');
        $searchDimmer.animate({opacity: 1}, 500, 'swing');

        // Slide in the search form from the right and center it.
        $searchForm.css('display', 'block');
        $searchForm.animate({ right: '50%' }, 500, 'swing', function() {
            // Set a slight delay to ensure focus doesn't cause a scroll
            setTimeout(function() {
                const searchInput = $searchForm.find('.searchform__field');
                const closeButton = $searchForm.find('.modal-box-close');

                searchInput.focus();

                // Set tabIndex to ensure the close button is the next focusable element
                searchInput.on('keydown', function(e) {
                    if (e.key === 'Tab' && !e.shiftKey) {
                        e.preventDefault();
                        closeButton.focus();
                    }
                });
            }, 100);

        });
    });

    // Function to close the search form and hide the dimmer.
    function closeSearchForm() {
        // Slide out the search form to the right and hide it.
        $searchForm.animate({right: '-100%'}, 500, 'swing', function () {
            $(this).css('display', 'none');
        });
        // Fade out the dimmer and hide it.
        $searchDimmer.animate({ opacity: 0 }, 150);
        setTimeout(function() {
            $searchDimmer.css('display', 'none');
        }, 750);
        $('body').removeClass('no-scroll');
    }

    // Close the search form when the dimmer is clicked
    $searchDimmer.on('click', closeSearchForm);

    // Close the search form when the close button inside the form is clicked
    $('.modal-box-close').on('click', closeSearchForm);

    // Close the search form when the Escape key is pressed
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            closeSearchForm();
        }
    });


});